import React from 'react';

export const AppFooter = (props) => {
    const onClickPolicy = (e) => {
        props.onClickPolicy(e);
    }
    
    const onClickCookies= (e) => {
        props.onClickCookies(e);
       
    }
    return (
      

        <div className="flex" style={{backgroundColor:'#F5F5F5',marginTop:'2rem'}}>

      
  
        <div className="mt-2 p-3  col-6">
        <div className="text-xl font-medium text-900 mb-4">Info</div>
        <div className="text-sm font-medium text-500 mb-2" style={{cursor:'pointer'}} onClick={onClickCookies}>Cookie Policy</div>
     
        </div>
        </div>
        


     /*
        We use cookies on our website to give you the most relevant experience by remembering
         your preferences and repeat visits. By clicking “Accept”, you consent to the use of ALL the cookies.


         https://ownyourbusiness.tech/it/cookies/
    */
    
    );
}   
